__turbopack_context__.v({
  "className": "inter_195cef7-module__R2ArRG__className",
  "variable": "inter_195cef7-module__R2ArRG__variable",
});
